import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import company from './modules/company'
import account from './modules/account'
import intent from './modules/intent'
import intentEmployee from './modules/intentEmployee'
import contact from './modules/contact'
import people from './modules/people'
import sequence from './modules/sequence'
import schema from './modules/schema'
import services from './modules/services'
import permission from './modules/permission'
import apiKeys from './modules/apiKeys'
import notification from './modules/notification'
import common from './modules/common'
import base from './modules/base'
import aiConversations from './modules/aiConversations'
import filter from './modules/filter';
import crm from './modules/crm'
import monitors from './modules/monitors'
import redeemCsv from './modules/redeemCsv'
import inbox from './modules/inbox'
import expansions from './modules/expansions'
import watchlist from './modules/watchlist'
import sheets from './modules/sheets'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    people,
    company,
    account,
    intent,
    intentEmployee,
    contact,
    sequence,
    schema,
    services,
    permission,
    apiKeys,
    notification,
    common,
    base,
    aiConversations,
    filter,
    crm,
    monitors,
    redeemCsv,
    inbox,
    expansions,
    watchlist,
    sheets
  },
  getters
})
export default store
